import { render, staticRenderFns } from "./DutyTypesList.vue?vue&type=template&id=18ab725c&scoped=true&"
import script from "./DutyTypesList.vue?vue&type=script&lang=js&"
export * from "./DutyTypesList.vue?vue&type=script&lang=js&"
import style0 from "./DutyTypesList.vue?vue&type=style&index=0&id=18ab725c&lang=scss&scoped=true&"
import style1 from "./DutyTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab725c",
  null
  
)

export default component.exports